import { useNetworkStore } from "../../stores/useNetworkStore"
import { RemoteAvatar } from "./RemoteAvatar"

// Render de todos los peers actuales del cuásar. Reactivo al Map de Zustand.
export function RemoteAvatars() {
    const peers = useNetworkStore((s) => s.peers)
    const list = Array.from(peers.values())
    return (
        <>
            {list.map((peer) => (
                <RemoteAvatar key={peer.id} peer={peer} />
            ))}
        </>
    )
}
